import React, {useEffect, useState, useCallback} from "react";
import axios from "axios";
import { Box, Table, Button } from "@allxsmith/bestax-bulma";
import Nav from "../Nav/Nav";
import LoadingSpinner from "../Utils/Spinner";

export default function VanPartsIncome() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [start, setStart] = useState("");

    const load = useCallback(() => {
        setLoading(true);
        axios.get("/api/vanparts-income" + (start ? "?from=" + start : ""))
            .then(r => setData(r.data))
            .catch(() => setData({error: true}))
            .finally(() => setLoading(false));
    }, [start]);

    useEffect(() => { load(); }, [load]);

    document.title = "Van Parts Income";
    const fmtDate = d => d ? new Date(d).toLocaleDateString("en-GB") : "";
    const money = n => "£" + Number(n || 0).toFixed(2);
    const receipts = (data && data.receipts) || [];
    const total = receipts.reduce((s, x) => s + Number(x.amount || 0), 0);

    return (
        <div>
            <Nav/>
            <br/><br/>
            <Box>
                <h1 className="title">Van Parts Direct - income</h1>
                <p className="has-text-grey" style={{marginBottom: "14px"}}>Money-in received for Van Parts Direct (from Xero), excluding WorldPay payments. Read-only - so a BACS/bank payment is never missed.</p>
                <div className="field is-grouped" style={{marginBottom: "14px", alignItems: "flex-end"}}>
                    <div className="control">
                        <label className="label is-small">From</label>
                        <input className="input is-small" type="date" value={start} onChange={e => setStart(e.target.value)}/>
                    </div>
                    <div className="control">
                        <Button color={"primary"} onClick={load}>Apply</Button>
                    </div>
                </div>
                {loading ? <LoadingSpinner/> : null}
                {!loading && data && data.configured === false ? <p className="has-text-grey">Xero link not configured.</p> : null}
                {!loading && data && data.error ? <p className="has-text-danger">Could not load income.</p> : null}
                {!loading && data && data.configured && !data.error ?
                    <div>
                        <p style={{marginBottom: "10px"}}><strong>{receipts.length}</strong> receipt(s) &middot; total <strong>{money(total)}</strong></p>
                        <Table>
                            <thead>
                                <tr><th>Date</th><th>Payer</th><th>Reference</th><th>Account</th><th style={{textAlign: "right"}}>Amount</th></tr>
                            </thead>
                            <tbody>
                                {receipts.map((x, i) =>
                                    <tr key={i}>
                                        <td>{fmtDate(x.date)}</td>
                                        <td>{x.payer}</td>
                                        <td>{x.reference}</td>
                                        <td>{x.account}</td>
                                        <td style={{textAlign: "right"}}>{money(x.amount)}</td>
                                    </tr>
                                )}
                                {receipts.length === 0 ? <tr><td colSpan={5} className="has-text-grey">No non-WorldPay receipts in this period.</td></tr> : null}
                            </tbody>
                        </Table>
                        {data.ok === false ? <p className="has-text-warning">Note: {data.detail || "Xero fetch issue"}.</p> : null}
                    </div> : null}
            </Box>
        </div>
    );
}
